import styled from 'styled-components'

import breakpoints from '../../theme/breakpoints'

export const Text = styled.p`
  ${({ theme }) => theme.textStyles.H5};
  font-size: 1.6rem;
  color: ${({ theme }) => theme.colors.royalBlue};
  &::after {
    content: '';
    display: block;
    width: 5rem;
    height: 0.2rem;
    background-color: ${({ theme }) => theme.colors.royalBlue};
    margin-top: 0.8rem;
  }

  ${breakpoints.up('tablet')} {
    font-size: 1.8rem;
  }
`
